import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    // Let the protected layout hydrate the HttpOnly trusted-device session
    // before deciding whether the user really needs the login chooser.
    // `/home` then picks the landing page by who signed in (lễ tân → Lịch chụp).
    throw redirect({ to: "/home", replace: true });
  },
});
